"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.gridDefaultProps = exports.GRID_SPACING_CSS_VARIABLE_NAME = exports.GRID_SPACING = exports.GRID_ITEM_CLASS_NAME = exports.GRID_COLUMNS = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0, _defineProperty2.default)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
var GRID_COLUMNS = {
  lg: 12,
  md: 8,
  sm: 4
};
exports.GRID_COLUMNS = GRID_COLUMNS;
var GRID_SPACING = {
  xl: 32,
  lg: 32,
  md: 24,
  sm: 16
};
exports.GRID_SPACING = GRID_SPACING;
var GRID_ITEM_CLASS_NAME = 'stencil-grid-item';
exports.GRID_ITEM_CLASS_NAME = GRID_ITEM_CLASS_NAME;
var GRID_SPACING_CSS_VARIABLE_NAME = '--stencil-grid-spacing';
exports.GRID_SPACING_CSS_VARIABLE_NAME = GRID_SPACING_CSS_VARIABLE_NAME;
var gridDefaultProps = _objectSpread({}, GRID_COLUMNS);
exports.gridDefaultProps = gridDefaultProps;